"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRelayerTransactionResponse = void 0;
const tslib_1 = require("tslib");
const types_1 = require("../types");
class ClientRelayerTransactionResponse {
    constructor(transactionID, state, transactionHash, client) {
        this.transactionID = transactionID;
        this.state = state;
        this.transactionHash = transactionHash;
        this.hash = transactionHash;
        this.client = client;
    }
    getTransaction() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.client.getTransaction(this.transactionID);
        });
    }
    wait() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.client.pollUntilState(this.transactionID, [
                types_1.RelayerTransactionState.STATE_MINED,
                types_1.RelayerTransactionState.STATE_CONFIRMED,
            ], 30);
        });
    }
}
exports.ClientRelayerTransactionResponse = ClientRelayerTransactionResponse;
